// src/infrastructure/notifications/notificationConfig.ts
import { NotificationPosition } from './NotificationService.types';

/**
 * Default configuration for notifications
 */
export const NOTIFICATION_CONFIG = {
  /**
   * Default position for notifications
   */
  POSITION: 'top-right' as NotificationPosition,

  /**
   * Default auto-close duration (milliseconds)
   */
  AUTO_CLOSE_DURATION: 5000,

  /**
   * Duration for error notifications (longer to allow user to read)
   */
  ERROR_DURATION: 7000,

  /**
   * Duration for success notifications
   */
  SUCCESS_DURATION: 4000,

  /**
   * Maximum number of notifications to show at once
   */
  MAX_NOTIFICATIONS: 5,

  /**
   * Z-index for notification container
   */
  Z_INDEX: 9999,

  /**
   * Show close button by default
   */
  WITH_CLOSE_BUTTON: true,

  /**
   * Colors for different notification types
   */
  COLORS: {
    success: 'green',
    error: 'red',
    warning: 'yellow',
    info: 'blue'
  }
} as const;
